module.exports = __webpack_public_path__ + "assets/img/WHATSAPP.48438627.svg";